/**
 * The rule rows themselves (fix Z2.1) — rows over hairlines, no cards
 * (the Info panel's own idiom, R6.1): a title plus a muted detail line,
 * the detail omitted when the catalogue has none (an unknown, humanised
 * key). Shared by the Info tab's section (`index.tsx`) and the action bar's
 * popover (`rail/live/ActionBar/ParentalControlsButton.tsx`), which passes
 * `compact` to tighten the vertical rhythm for its smaller box.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {SPACE} from '../../../theme/tokens';
import {Divider, Txt} from '../../../ui';
import {ParentalRule} from './rules';

export type ParentalRulesListProps = {
  rules: ParentalRule[];
  compact?: boolean;
};

function ParentalRulesList({rules, compact}: ParentalRulesListProps) {
  return (
    <View style={compact ? styles.listCompact : styles.list}>
      {rules.map((rule, index) => (
        <React.Fragment key={rule.key}>
          {index > 0 && <Divider />}
          <View style={compact ? styles.rowCompact : styles.row}>
            <Txt variant="rowName">{rule.title}</Txt>
            {!!rule.detail && (
              <Txt variant="caption" tone="muted">
                {rule.detail}
              </Txt>
            )}
          </View>
        </React.Fragment>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  list: {
    gap: SPACE.sm,
  },
  listCompact: {
    gap: SPACE.xs,
  },
  row: {
    gap: SPACE.xs / 2,
    paddingVertical: SPACE.xs,
  },
  rowCompact: {
    gap: SPACE.xs / 2,
  },
});

export default React.memo(ParentalRulesList);
